import { AxiosResponse } from 'axios';
import AxiosInstance from '../utils/axios';
import {
  SignupRequestPayload,
  LoginRequestPayload,
  ForgotPasswordRequestPayload,
  VerifyCodeRequestPayload,
  ChangePasswordRequestPayload,
  InviteBabysitterRequestPayload,
  paymentRequestPayload,
  DecreaseStageRequestPayload,
  SearchConsumersRequestPayload,
  GetConsumerCheckInRequestPayload,
  LogoutRequestPayload,
  GetConsumerDetailsRequestPayload,
  GetTermsAndPrivacyContentRequestPayload,
  RequestCheckin,
  AgoraTokenRequestPayload,
} from './types/APIRequestType';
import { AgoraTokenResponse, LoginResponse, SignupResponse } from './types/APIResponseType';

// auth apis
export const register = (
  data: SignupRequestPayload,
): Promise<AxiosResponse<SignupResponse>> =>
  AxiosInstance.post(`/api/v1/auth/register`, data);
export const login = (
  data: LoginRequestPayload,
): Promise<AxiosResponse<LoginResponse>> =>
  AxiosInstance.post(`/api/v1/auth/login`, data);
export const forgotPassword = (data: ForgotPasswordRequestPayload) =>
  AxiosInstance.post(`/api/v1/auth/forgot-password`, data);
export const verifyCode = (data: VerifyCodeRequestPayload) =>
  AxiosInstance.post(`/api/v1/auth/otp-verification`, data);
export const changePassword = (data: ChangePasswordRequestPayload) =>
  AxiosInstance.post(`/api/v1/auth/reset-password`, data);
export const getTermsAndPrivacyContent = (
  data: GetTermsAndPrivacyContentRequestPayload,
) => AxiosInstance.post(`/api/v1/content/get-content-by-type`, data);

export const logout = (data: LogoutRequestPayload) =>
  AxiosInstance.post(`/api/v1/auth/logout`, data);

export const getStage = () => AxiosInstance.get(`/api/v1/auth/get-stage`);

export const decreaseStage = (data: DecreaseStageRequestPayload) =>
  AxiosInstance.put(
    `/api/v1/subscription/decrease-stage-for-payment-failure`,
    data,
  );

//profile apis
export const createProfile = (data: FormData) =>
  AxiosInstance.post(`/api/v1/profile/create-profile`, data);
export const getProfile = () =>
  AxiosInstance.get(`/api/v1/profile/get-profile`);
export const editProfile = (data: FormData) =>
  AxiosInstance.put(`/api/v1/profile/update-profile`, data);
export const inviteBabysitter = (data: InviteBabysitterRequestPayload) =>
  AxiosInstance.post(`/api/v1/profile/invite-babysitter`, data);
export const changeProfilePassword = (data: any) =>
  AxiosInstance.post(`/api/v1/auth/change-password`, data);

//manage tickets apis
export const getTickets = (page: number, limit: number, data: any) =>
  AxiosInstance.post(
    `/api/v1/support/tickets-list?page=${page}&limit=${limit}`,
    data,
  );

export const createTicket = (data: any) =>
  AxiosInstance.post(`/api/v1/support/create-ticket`, data);
export const getTicketById = (id: string) =>
  AxiosInstance.get(`/api/v1/support/get-ticket-by-Id/${id}`);

//payment api
export const createSubscription = (data: paymentRequestPayload) =>
  AxiosInstance.post(`/api/v1/subscription/create-subscription`, data);
//subscription status apis
export const getSubscriptionStatus = () =>
  AxiosInstance.get(`/api/v1/subscription/consumer-web-subscription-status`);
export const changeSubscriptionStatus = (data: any) =>
  AxiosInstance.put(
    `/api/v1/subscription/consumer-web-subscription-details`,
    data,
  );
export const getCardDetails = () =>
  AxiosInstance.get(`/api/v1/subscription/list-cards`);
export const addCardDetails = (data: any) =>
  AxiosInstance.post(`/api/v1/subscription/add-card`, data);
//dashboard api
export const getDashboard = (page: number, limit: number) =>
  AxiosInstance.get(
    `/api/v1/subscription/consumer-web-dashboard?page=${page}&limit=${limit}`,
  );
export const getBabysitterDashboard = (page: number, limit: number) =>
  AxiosInstance.get(
    `/api/v1/submission/babysitter-web-dashboard?page=${page}&limit=${limit}`,
  );

export const searchConsumers = (data: SearchConsumersRequestPayload) =>
  AxiosInstance.post(`/api/v1/submission/search-consumers`, data);

export const getConsumerCheckInCount = (
  id: string,
  data: GetConsumerCheckInRequestPayload,
) =>
  AxiosInstance.post(
    `/api/v1/submission/consumer-details/${id}/checkIn-count`,
    data,
  );

export const getConsumerDetails = (
  id: string,
  data: GetConsumerDetailsRequestPayload,
  page?: number,
  limit?: number,
) =>
  AxiosInstance.post(
    `/api/v1/submission/consumer-details/${id}?page=${page}&limit=${limit}`,
    data,
  );

export const approveFace = (id: string) =>
  AxiosInstance.put(`/api/v1/submission/manual-face-authentication/${id}`);

export const uploadImage = (data: FormData) =>
  AxiosInstance.post(`/api/v1/group/upload-img-inside-group-chat`, data);

export const getNotificationsList = (page: number, limit: number) =>
  AxiosInstance.get(
    `/api/v1/notification/get-notifications-list?page=${page}&limit=${limit}`,
  );

export const getUnReadNotificationsCount = () =>
  AxiosInstance.get(`/api/v1/notification/get-unread-notifications-count`);

export const markNotificationAsRead = () =>
  AxiosInstance.put(`/api/v1/notification/mark-notification-as-read`);

export const requestCheckin = (data: RequestCheckin) =>
  AxiosInstance.post(`/api/v1/submission/supervisor-imposed-checkin`, data);

export const getAgoraToken = (
  data: AgoraTokenRequestPayload,
): Promise<AxiosResponse<AgoraTokenResponse>> =>
  AxiosInstance.post(`/api/v1/agora/token`, data);
